module.exports = require('../lib/node_modules/@grapecity/ar-js-viewer.js');